import leo from './leo';

const ProductEvents = {
  sendProductViewEvent(product) {
    if (product) {
      leo?.capture('product', 'view', {
        product_id: product?.productId,
        price: product?.price?.formattedPrice,
        discount: '',
        sku: product?.sku,
      });
    }
  },

  sendProductListViewEvent(products = []) {
    const productList = products?.map((product) => ({
      product_id: product?.productId,
      price: product?.price?.[0]?.formattedPrice || '',
      sku: product?.sku,
      listing_id: product?.listingId || '',
      campaign: product?.campaignText || null,
      position: product?.position,
      discount: product?.price?.[0]?.discountRate || 0,
    }));
    leo?.capture('product_list', 'view', {
      product_list: productList,
    });
  },

  sendRecoProductListViewEvent(products) {
    const productList = products?.map((product) => ({
      product_id: product?.productId,
      price: product?.originalPrice?.value?.toFixed(2),
      sku: product?.sku,
      listing_id: product?.listingId || '',
      campaign: product?.campaignText || null,
      position: product?.position,
      discount: product?.price?.[0]?.discountRate || 0,
    }));
    leo?.capture('reco_product', 'view', {
      product_list: productList,
    });
  },

  sendSponsoredProductListViewEvent(products) {
    const productList = products?.map((product) => ({
      product_id: product?.productId,
      price: product?.originalPrice?.value?.toFixed(2),
      sku: product?.sku,
      listing_id: product?.listingId || '',
      campaign: product?.campaignText || null,
      position: product?.position,
      discount: product?.price?.[0]?.discountRate || 0,
    }));
    leo?.capture('sponsored_product_list', 'view', {
      product_list: productList,
    });
  },

  sendAddToCartClickEvent({product, position, location}) {
    leo?.capture('add_to_cart', 'click', {
      product_id: product?.productId,
      sku:product?.sku || '',
      position,
      location
    });
  },
};

export default ProductEvents;
